var _path, _g, _path2, _g2, _path3, _rect, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaultTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 88,
    viewBox: "0 0 76 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8511 6H37.9924H12.1336C7.94587 6 7 21 7 21H13.9338H38H62.0662H69C69 21 68.0541 6 63.8511 6Z",
    fill: "#301C6B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_979_6084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0038 6H12C12.698 6 13.304 12.2273 13.795 19.9906C14.2015 26.4541 14.5313 44.3229 14.7538 54.1294C14.8305 57.4238 16.7405 60.4679 19.8318 62.2055L29.9726 67.9254C34.8895 70.6915 41.1105 70.6915 46.0274 67.9254L56.1682 62.2124C59.2595 60.4749 61.1695 57.4307 61.2462 54.1364C61.4687 44.3298 61.7908 26.4541 62.205 19.9975C62.696 12.2273 63.3096 6 64 6H38.0038Z",
    fill: "#302E66"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_979_6084",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 6,
    width: 52,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0038 6H12C12.698 6 13.304 12.2273 13.795 19.9906C14.2015 26.4542 14.5313 44.3229 14.7538 54.1295C14.8305 57.4238 16.7405 60.468 19.8318 62.2055L29.9726 67.9254C34.8895 70.6916 41.1105 70.6916 46.0274 67.9254L56.1682 62.2124C59.2595 60.4749 61.1695 57.4308 61.2462 54.1364C61.4687 44.3298 61.7908 26.4542 62.205 19.9975C62.696 12.2273 63.3096 6 64 6H38.0038Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_979_6084)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_979_6084)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 19.8329,
    ry: 24.4889,
    transform: "matrix(4.6334e-08 1 1 -4.12372e-08 38.5006 -4.10358)",
    fill: "#944FD8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_979_6084)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 28.9048,
    ry: 35.6905,
    transform: "matrix(4.6334e-08 1 1 -4.12372e-08 38.6406 92.9653)",
    fill: "#3AF0F0"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.17 13.727L29.803 20H28.858L26.491 13.727H27.364L29.335 19.136L31.306 13.727H32.17ZM32.762 17.516C32.762 17.012 32.864 16.571 33.068 16.193C33.272 15.809 33.551 15.512 33.905 15.302C34.265 15.092 34.664 14.987 35.102 14.987C35.534 14.987 35.909 15.08 36.227 15.266C36.545 15.452 36.782 15.686 36.938 15.968V15.068H37.766V20H36.938V19.082C36.776 19.37 36.533 19.61 36.209 19.802C35.891 19.988 35.519 20.081 35.093 20.081C34.655 20.081 34.259 19.973 33.905 19.757C33.551 19.541 33.272 19.238 33.068 18.848C32.864 18.458 32.762 18.014 32.762 17.516ZM36.938 17.525C36.938 17.153 36.863 16.829 36.713 16.553C36.563 16.277 36.359 16.067 36.101 15.923C35.849 15.773 35.57 15.698 35.264 15.698C34.958 15.698 34.679 15.77 34.427 15.914C34.175 16.058 33.974 16.268 33.824 16.544C33.674 16.82 33.599 17.144 33.599 17.516C33.599 17.894 33.674 18.224 33.824 18.506C33.974 18.782 34.175 18.995 34.427 19.145C34.679 19.289 34.958 19.361 35.264 19.361C35.57 19.361 35.849 19.289 36.101 19.145C36.359 18.995 36.563 18.782 36.713 18.506C36.863 18.224 36.938 17.897 36.938 17.525ZM43.524 15.068V20H42.705V19.271C42.549 19.523 42.33 19.721 42.048 19.865C41.772 20.003 41.466 20.072 41.13 20.072C40.746 20.072 40.401 19.994 40.095 19.838C39.789 19.676 39.546 19.436 39.366 19.118C39.192 18.8 39.105 18.413 39.105 17.957V15.068H39.915V17.849C39.915 18.335 40.038 18.71 40.284 18.974C40.53 19.232 40.866 19.361 41.292 19.361C41.73 19.361 42.075 19.226 42.327 18.956C42.579 18.686 42.705 18.293 42.705 17.777V15.068H43.524ZM45.7259 13.34V20H44.9069V13.34H45.7259ZM48.1207 15.743V18.65C48.1207 18.89 48.1717 19.061 48.2737 19.163C48.3757 19.259 48.5527 19.307 48.8047 19.307H49.4077V20H48.6697C48.2137 20 47.8717 19.895 47.6437 19.685C47.4157 19.475 47.3017 19.13 47.3017 18.65V15.743H46.6627V15.068H47.3017V13.826H48.1207V15.068H49.4077V15.743H48.1207Z",
    fill: "#F7F7FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_979_6084",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 32,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_979_6084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.3184,
    y: 51.2832,
    width: 4.39762,
    height: 13.8443,
    rx: 2,
    transform: "rotate(-180 43.3184 51.2832)",
    fill: "url(#paint0_linear_979_6084)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5021,
    cy: 50.6876,
    r: 1.71206,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5823 49.6946L43.4883 49.7886C43.7126 50.0339 43.837 50.3543 43.837 50.6868C43.837 51.0192 43.7126 51.3396 43.4883 51.585L43.5823 51.679C43.8318 51.4084 43.9703 51.0538 43.9703 50.6857C43.9703 50.3176 43.8318 49.963 43.5823 49.6924V49.6946Z",
    fill: "#5A5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.605 49.7027C41.8503 49.4784 42.1707 49.354 42.5032 49.354C42.8356 49.354 43.156 49.4784 43.4014 49.7027L43.4954 49.6087C43.2248 49.3592 42.8702 49.2207 42.5021 49.2207C42.134 49.2207 41.7794 49.3592 41.5088 49.6087L41.605 49.7027Z",
    fill: "#5A5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5172 51.5857C41.2931 51.3405 41.1689 51.0202 41.1689 50.688C41.1689 50.3558 41.2931 50.0356 41.5172 49.7903L41.4232 49.6963C41.1737 49.9669 41.0352 50.3215 41.0352 50.6896C41.0352 51.0577 41.1737 51.4123 41.4232 51.6829L41.5172 51.5857Z",
    fill: "#5A5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4001 51.6719C43.1548 51.8962 42.8344 52.0206 42.502 52.0206C42.1695 52.0206 41.8491 51.8962 41.6038 51.6719L41.5098 51.7659C41.7804 52.0154 42.135 52.1539 42.5031 52.1539C42.8711 52.1539 43.2257 52.0154 43.4964 51.7659L43.4001 51.6719Z",
    fill: "#5A5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0961 50.3735C43.0773 50.1773 42.9081 50.1115 42.6941 50.0914V49.8213H42.5286V50.0864C42.485 50.0864 42.4405 50.0864 42.3963 50.0864V49.8213H42.2321V50.0933H41.8965V50.2704C41.8965 50.2704 42.0187 50.2682 42.0168 50.2704C42.0389 50.268 42.061 50.2742 42.0785 50.2877C42.0961 50.3013 42.1076 50.3211 42.1108 50.3431V51.0877C42.1104 51.0954 42.1084 51.103 42.1049 51.11C42.1015 51.1169 42.0967 51.1231 42.0908 51.1281C42.085 51.1333 42.0783 51.1372 42.0709 51.1397C42.0636 51.1422 42.0559 51.1431 42.0482 51.1425C42.0504 51.1444 41.9278 51.1425 41.9278 51.1425L41.8965 51.3403H42.229V51.6167H42.3945V51.3444H42.5267V51.6155H42.6925V51.3422C42.972 51.3253 43.167 51.2563 43.1914 50.9946C43.2112 50.784 43.1121 50.69 42.9539 50.6521C43.0501 50.6048 43.1096 50.517 43.0961 50.3735ZM42.8642 50.962C42.8642 51.1676 42.512 51.1441 42.3998 51.1441V50.7793C42.512 50.7796 42.8642 50.7474 42.8642 50.962ZM42.7875 50.4481C42.7875 50.6361 42.4935 50.6132 42.4001 50.6132V50.2817C42.4935 50.2817 42.7875 50.2522 42.7875 50.4481Z",
    fill: "#F09242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5018 52.3997C42.1632 52.3996 41.8322 52.2992 41.5507 52.111C41.2692 51.9229 41.0498 51.6555 40.9203 51.3427C40.7908 51.0299 40.7569 50.6856 40.823 50.3536C40.889 50.0215 41.0521 49.7165 41.2915 49.477C41.5309 49.2376 41.8359 49.0746 42.168 49.0085C42.5001 48.9424 42.8443 48.9763 43.1571 49.1058C43.47 49.2354 43.7373 49.4548 43.9255 49.7363C44.1136 50.0178 44.2141 50.3487 44.2142 50.6873C44.2142 50.9122 44.1699 51.1349 44.0839 51.3427C43.9979 51.5505 43.8717 51.7392 43.7127 51.8983C43.5537 52.0573 43.3649 52.1834 43.1571 52.2694C42.9494 52.3555 42.7267 52.3997 42.5018 52.3997ZM42.5018 49.1091C42.1898 49.1093 41.885 49.2021 41.6257 49.3755C41.3665 49.549 41.1644 49.7954 41.0452 50.0837C40.926 50.372 40.8949 50.6891 40.9558 50.995C41.0168 51.3009 41.1671 51.5819 41.3877 51.8025C41.6083 52.023 41.8894 52.1732 42.1953 52.234C42.5013 52.2949 42.8184 52.2636 43.1066 52.1443C43.3948 52.0249 43.6412 51.8228 43.8146 51.5635C43.9879 51.3042 44.0805 50.9993 44.0807 50.6873C44.0807 50.48 44.0399 50.2747 43.9606 50.0831C43.8813 49.8916 43.765 49.7175 43.6184 49.5709C43.4717 49.4244 43.2976 49.3081 43.106 49.2289C42.9145 49.1496 42.7091 49.1089 42.5018 49.1091Z",
    fill: "#2A233A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1897 46.3911C44.4172 46.3911 45.4048 45.4036 45.4048 44.176C45.4048 42.9485 44.4172 41.9609 43.1897 41.9609C41.9622 41.9609 40.9746 42.9485 40.9746 44.176C40.9746 45.4036 41.9622 46.3911 43.1897 46.3911Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7993 44.5267C43.7993 44.2037 43.6054 44.0929 43.2178 44.0468C42.9409 44.0099 42.8855 43.936 42.8855 43.8068C42.8855 43.6776 42.9778 43.5945 43.1624 43.5945C43.3285 43.5945 43.4208 43.6499 43.467 43.7884C43.4762 43.8161 43.5039 43.8345 43.5316 43.8345H43.6793C43.7162 43.8345 43.7439 43.8068 43.7439 43.7699V43.7607C43.707 43.5576 43.5408 43.4007 43.3285 43.3823V43.1608C43.3285 43.1238 43.3009 43.0962 43.2547 43.0869H43.1163C43.0793 43.0869 43.0517 43.1146 43.0424 43.1608V43.373C42.7655 43.41 42.5902 43.5945 42.5902 43.8253C42.5902 44.1299 42.7748 44.2498 43.1624 44.296C43.4208 44.3421 43.5039 44.3975 43.5039 44.5452C43.5039 44.6929 43.3747 44.7944 43.1993 44.7944C42.9594 44.7944 42.8763 44.6929 42.8486 44.5544C42.8394 44.5175 42.8117 44.499 42.784 44.499H42.6271C42.5902 44.499 42.5625 44.5267 42.5625 44.5637V44.5729C42.5994 44.8036 42.7471 44.9697 43.0517 45.0159V45.2374C43.0517 45.2743 43.0793 45.302 43.1255 45.3112H43.2639C43.3009 45.3112 43.3285 45.2836 43.3378 45.2374V45.0159C43.6147 44.9697 43.7993 44.7759 43.7993 44.5267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7186 45.4963C41.9987 45.2378 41.6295 44.4349 41.8971 43.7242C42.0356 43.3365 42.3402 43.0412 42.7186 42.9028C42.7555 42.8843 42.7739 42.8566 42.7739 42.8105V42.6813C42.7739 42.6443 42.7555 42.6166 42.7186 42.6074C42.7093 42.6074 42.6909 42.6074 42.6816 42.6166C41.8048 42.8935 41.3249 43.8257 41.6018 44.7025C41.7679 45.2194 42.1648 45.6163 42.6816 45.7824C42.7186 45.8008 42.7555 45.7824 42.7647 45.7455C42.7739 45.7362 42.7739 45.727 42.7739 45.7086V45.5793C42.7739 45.5516 42.7462 45.5147 42.7186 45.4963ZM43.6969 42.6166C43.66 42.5982 43.623 42.6166 43.6138 42.6536C43.6046 42.6628 43.6046 42.672 43.6046 42.6905V42.8197C43.6046 42.8566 43.6323 42.8935 43.66 42.912C44.3799 43.1704 44.7491 43.9734 44.4814 44.6841C44.343 45.0717 44.0384 45.3671 43.66 45.5055C43.623 45.5239 43.6046 45.5516 43.6046 45.5978V45.727C43.6046 45.7639 43.623 45.7916 43.66 45.8008C43.6692 45.8008 43.6877 45.8008 43.6969 45.7916C44.5737 45.5147 45.0536 44.5825 44.7768 43.7057C44.6106 43.1796 44.2045 42.7828 43.6969 42.6166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4219 50.3603C47.5215 50.3603 48.4062 49.4756 48.4062 48.376C48.4062 47.2763 47.5215 46.3916 46.4219 46.3916C45.3222 46.3916 44.4375 47.2763 44.4375 48.376C44.4375 49.4756 45.3222 50.3603 46.4219 50.3603Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6921 48.5965C46.677 48.5977 46.599 48.6024 46.425 48.6024C46.2865 48.6024 46.1882 48.5982 46.1537 48.5965C45.6187 48.5727 45.2194 48.4786 45.2194 48.3658C45.2194 48.253 45.6187 48.159 46.1537 48.1348V48.5027C46.1887 48.5053 46.2889 48.5113 46.4273 48.5113C46.5935 48.5113 46.6767 48.5043 46.6916 48.5029V48.135C47.2255 48.1591 47.624 48.2533 47.624 48.3658C47.624 48.4783 47.2256 48.5725 46.6916 48.5964L46.6921 48.5965ZM46.6921 48.097V47.7677H47.4372V47.2656H45.4087V47.7677H46.1536V48.0969C45.5481 48.125 45.0928 48.2463 45.0928 48.3916C45.0928 48.537 45.5481 48.6581 46.1536 48.6864V49.7415H46.692V48.686C47.2961 48.6579 47.7507 48.5367 47.7507 48.3915C47.7507 48.2463 47.2965 48.1251 46.692 48.0969L46.6921 48.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 39.0293,
    width: 0.940048,
    height: 4.07354,
    rx: 0.470024,
    fill: "url(#paint1_linear_979_6084)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 45.873,
    width: 0.940048,
    height: 4.07354,
    rx: 0.470024,
    fill: "url(#paint2_linear_979_6084)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8899 39.7549C47.7795 39.7549 48.5005 40.476 48.5005 41.3655C48.5005 42.255 47.7795 42.976 46.8899 42.976C46.0004 42.976 45.2793 42.255 45.2793 41.3655C45.2793 40.476 46.0004 39.7549 46.8899 39.7549Z",
    fill: "url(#paint3_linear_979_6084)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9491 41.4792H47.5611C47.5742 41.4792 47.5803 41.4792 47.5813 41.4621C47.5863 41.3998 47.5863 41.3372 47.5813 41.2749C47.5813 41.2628 47.5752 41.2578 47.5621 41.2578H46.3442C46.3291 41.2578 46.325 41.2628 46.325 41.2769V41.4561C46.325 41.4792 46.325 41.4792 46.3492 41.4792H46.9491ZM47.5129 41.0484C47.5147 41.0438 47.5147 41.0388 47.5129 41.0343C47.5027 41.0121 47.4906 40.9908 47.4765 40.9709C47.4554 40.9368 47.4304 40.9055 47.402 40.8773C47.3886 40.8602 47.3731 40.8449 47.3557 40.832C47.2686 40.7578 47.165 40.7053 47.0537 40.679C46.9975 40.6664 46.9401 40.6603 46.8826 40.6608H46.342C46.327 40.6608 46.3249 40.6669 46.3249 40.68V41.0373C46.3249 41.0524 46.3249 41.0564 46.3441 41.0564H47.5057C47.5057 41.0564 47.5157 41.0544 47.5178 41.0484H47.5128H47.5129ZM47.5129 41.6886C47.4958 41.6867 47.4786 41.6867 47.4615 41.6886H46.3452C46.3301 41.6886 46.325 41.6886 46.325 41.7087V42.0581C46.325 42.0741 46.325 42.0782 46.3452 42.0782H46.8605C46.8852 42.0801 46.9098 42.0784 46.934 42.0732C47.0088 42.0678 47.0823 42.0516 47.1525 42.0249C47.178 42.016 47.2026 42.0045 47.2259 41.9907H47.2329C47.3538 41.9278 47.4519 41.8291 47.5138 41.7079C47.5138 41.7079 47.5208 41.6927 47.5129 41.6887V41.6886ZM46.1227 42.2593V42.2533V42.0188V41.9393V41.7027C46.1227 41.6896 46.1227 41.6876 46.1066 41.6876H45.8882C45.8761 41.6876 45.8711 41.6876 45.8711 41.6715V41.4803H46.1046C46.1177 41.4803 46.1227 41.4803 46.1227 41.4632V41.2739C46.1227 41.2618 46.1227 41.2589 46.1066 41.2589H45.8882C45.8761 41.2589 45.8711 41.2589 45.8711 41.2428V41.0656C45.8711 41.0545 45.8711 41.0516 45.8872 41.0516H46.1036C46.1187 41.0516 46.1227 41.0516 46.1227 41.0324V40.4899C46.1227 40.4738 46.1227 40.4697 46.1429 40.4697H46.8978C46.9526 40.4719 47.007 40.4779 47.0609 40.4878C47.1718 40.5084 47.2784 40.548 47.3759 40.6046C47.4406 40.6427 47.5001 40.6886 47.5531 40.7415C47.5929 40.7829 47.6289 40.8277 47.6608 40.8754C47.6924 40.9237 47.7187 40.9754 47.7394 41.0294C47.7419 41.0435 47.7554 41.0529 47.7695 41.0506H47.9497C47.9728 41.0506 47.9728 41.0506 47.9738 41.0727V41.2378C47.9738 41.2539 47.9678 41.258 47.9516 41.258H47.8127C47.7986 41.258 47.7946 41.258 47.7956 41.2761C47.8011 41.3374 47.8011 41.399 47.7956 41.4603C47.7956 41.4774 47.7956 41.4794 47.8148 41.4794H47.9737C47.9808 41.4885 47.9737 41.4975 47.9737 41.5067C47.9747 41.5183 47.9747 41.5301 47.9737 41.5418V41.6636C47.9737 41.6807 47.9687 41.6858 47.9536 41.6858H47.7633C47.7501 41.6833 47.7372 41.6918 47.7341 41.705C47.6888 41.8227 47.6163 41.9283 47.5227 42.013C47.4885 42.0438 47.4525 42.0728 47.415 42.0995C47.3747 42.1227 47.3355 42.1468 47.2942 42.166C47.2181 42.2002 47.1384 42.2254 47.0566 42.2414C46.9789 42.2553 46.9001 42.2616 46.821 42.2606H46.1224V42.2595L46.1227 42.2593Z",
    fill: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1924,
    y: 35.9619,
    width: 2.95346,
    height: 2.95346,
    rx: 1.47673,
    fill: "url(#paint4_linear_979_6084)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6905 36.5527L44.6787 36.5917V37.7216L44.6905 37.733L45.2282 37.423L44.6905 36.5527Z",
    fill: "#C1CCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6901 36.5527L44.1523 37.423L44.6901 37.733V37.1846V36.5527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6902 37.8323L44.6836 37.8402V38.2427L44.6902 38.2615L45.2283 37.5225L44.6902 37.8323Z",
    fill: "#C1CCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6901 38.2615V37.8323L44.1523 37.5225L44.6901 38.2615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6904 37.733L45.2281 37.423L44.6904 37.1846V37.733Z",
    fill: "#8197EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1523 37.423L44.6901 37.733V37.1846L44.1523 37.423Z",
    fill: "#C1CCF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2979,
    y: 37.4385,
    width: 13.7874,
    height: 13.8443,
    rx: 2,
    fill: "url(#paint5_linear_979_6084)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.2617,
    y: 42.2812,
    width: 0.940048,
    height: 4.07354,
    rx: 0.470024,
    fill: "url(#paint6_linear_979_6084)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1905 46.4025C38.5865 45.8213 38.8172 45.1206 38.8172 44.3657C38.8172 43.6051 38.5836 42.9015 38.1819 42.3175L39.5721 40.9274C39.837 40.6625 39.837 40.2352 39.5721 39.9731C39.3072 39.7082 38.8799 39.7082 38.6178 39.9731L37.2248 41.3661C36.6465 40.9758 35.9515 40.7479 35.2023 40.7479C34.4559 40.7479 33.7609 40.9758 33.1826 41.3632L31.7896 39.9731C31.5247 39.7082 31.0974 39.7082 30.8353 39.9731C30.5704 40.238 30.5704 40.6653 30.8353 40.9274L32.2198 42.3118C31.8181 42.8958 31.5817 43.6023 31.5817 44.3628C31.5817 45.1206 31.8153 45.8213 32.2112 46.4025L30.8325 47.7869C30.5676 48.0518 30.5676 48.4791 30.8325 48.7412C31.0974 49.0061 31.5247 49.0061 31.7868 48.7412L33.1655 47.3625C33.7438 47.7556 34.4445 47.9863 35.1966 47.9863C35.9515 47.9863 36.6522 47.7556 37.2334 47.3596L38.6149 48.7412C38.8799 49.0061 39.3072 49.0061 39.5692 48.7412C39.8342 48.4763 39.8342 48.049 39.5692 47.7869L38.1905 46.4025ZM35.1994 46.1062C34.2394 46.1062 33.4618 45.3285 33.4618 44.3685C33.4618 43.4086 34.2394 42.6309 35.1994 42.6309C36.1594 42.6309 36.9371 43.4086 36.9371 44.3685C36.9371 45.3285 36.1594 46.1062 35.1994 46.1062Z",
    fill: "url(#paint7_linear_979_6084)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_979_6084",
    x: 0,
    y: 0,
    width: 76,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_6084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_6084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_979_6084",
    x: -15.9883,
    y: -53.9365,
    width: 108.978,
    height: 99.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_979_6084"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_979_6084",
    x: -17.0498,
    y: 44.0605,
    width: 111.381,
    height: 97.8096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_979_6084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_979_6084",
    x1: 47.2526,
    y1: 58.2054,
    x2: 43.3184,
    y2: 58.2054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7770E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#808BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_979_6084",
    x1: 27.5,
    y1: 41.65,
    x2: 28.554,
    y2: 41.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8845B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_979_6084",
    x1: 27.5,
    y1: 48.4938,
    x2: 28.554,
    y2: 48.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1643E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8845B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_979_6084",
    x1: 46.8899,
    y1: 39.7549,
    x2: 46.8899,
    y2: 42.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC856"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_979_6084",
    x1: 46.1458,
    y1: 38.9154,
    x2: 43.1924,
    y2: 35.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#627EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_979_6084",
    x1: 43.6805,
    y1: 44.3606,
    x2: 30.3916,
    y2: 44.3606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_979_6084",
    x1: 40.2617,
    y1: 44.902,
    x2: 41.3157,
    y2: 44.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1643E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8845B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_979_6084",
    x1: 33.8955,
    y1: 45.6283,
    x2: 39.5073,
    y2: 40.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CCF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultTag);
export default __webpack_public_path__ + "static/media/vaultTag.46acea02d69ede393fa2563adbf0b929.svg";
export { ForwardRef as ReactComponent };